import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  levelEmployeesLength: 0,
  levelEmployees: [],
  levelEmployee: {},
  levelEmployeeError: "",
  formError: "",
};

export default function LevelEmployee(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_LEVEL_EMPLOYEE:
      return { ...state, loading: action.payload };
    case actions.LOADING_LEVEL_EMPLOYEE_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_LEVEL_EMPLOYEE:
      return { ...state, saveLoading: action.payload };
    case actions.GET_LEVEL_EMPLOYEE:
      return {
        ...state,
        levelEmployees: action.payload.levelEmployees,
        levelEmployeesLength: action.payload.levelEmployeesLength,
      };
    case actions.GET_LEVEL_EMPLOYEE_BY_ID:
      return {
        ...state, levelEmployee: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.LEVEL_EMPLOYEE_FAIL:
      return { ...state, levelEmployeeError: action.payload };
    default:
      return state;
  }
}
